<div class="overlay3"
     (click)="onClose()"></div>

<div class="popup-wrap type-bookmark"
     *ngIf="show" [@BookmarkInOut]>

  <div class="popup-head">
    <a class="popup-close-btn"
       (click)="onClose()"></a>
  </div>

  <div class="popup-body">

    <article class="popup-bookmark-form">

      <div class="bookmark-tit-box">
        책갈피 보기
      </div>

      <div class="bookmark-option-list">

        <!-- a href="#none" class="bookmark-box">
          <i class="ic ic-add"></i>
          <div class="txt-box">새 모음 추가</div>
        </a -->
        <!-- a href="#none" class="bookmark-box">
          <i class="ic ic-find"></i>
          <div class="txt-box">내가 찾은 단어 (12)</div>
        </a -->
        <a class="bookmark-box" (click)="goWordBookmark()">
          <i class="ic ic-write"></i>
          <div class="txt-box">단어 {{ bmInfo && bmInfo.numWordBookmark ? '(' + bmInfo.numWordBookmark + ')': '' }}</div>
        </a>
        <a class="bookmark-box" (click)="goSajaseungeoBookmark()">
          <i class="ic ic-book"></i>
          <div class="txt-box">사 자 성어 {{ bmInfo && bmInfo.numSajaseungeoBookmark ? '(' + bmInfo.numSajaseungeoBookmark + ')': '' }}</div>
        </a>
        <a class="bookmark-box" (click)="goSaseungBookmark()">
          <i class="ic ic-find"></i>
          <div class="txt-box">사 성 옥편 {{ bmInfo && bmInfo.numSaseungBookmark ? '(' + bmInfo.numSaseungBookmark + ')': '' }}</div>
        </a>
        <a class="bookmark-box" (click)="goDialectBookmark()">
          <i class="ic ic-talk"></i>
          <div class="txt-box">모두 우리말 {{ bmInfo && bmInfo.numDialectBookmark ? '(' + bmInfo.numDialectBookmark + ')': '' }}</div>
        </a>
        <!-- a class="bookmark-box" (click)="goProverbBookmark()">
          <i class="ic ic-book"></i>
          <div class="txt-box">속담 {{ bmInfo && bmInfo.numProverbBookmark ? '(' + bmInfo.numProverbBookmark + ')': '' }}</div>
        </a -->
        <a class="bookmark-box" (click)="goVideoBookmark()">
          <i class="ic ic-heart"></i>
          <div class="txt-box">좋아한 동영상 {{ bmInfo && bmInfo.numVideoBookmark ? '(' + bmInfo.numVideoBookmark + ')': '' }}</div>
        </a>

      </div>

    </article>


  </div>

</div>
